module.exports = __webpack_public_path__ + "img/business1.d92395de.jpg";